/* eslint-disable @typescript-eslint/naming-convention */
export interface TableModel {
	table_module: string; //"DHL",
	table_name: string; //"DRILL_HOLE",
	tab_title: string; //"Drill Hole",
	table_id: number; //3,
	child_table_ids?: string;
	is_interval_related?: string; //"N",
	allow_overlap?: string; //"N",
	allow_gaps?: string; //"N",
	allow_dups?: string; //"N",
	data_must_start_at_zero?: string; //"N",
	default_row?: string; //"N",
	standard_table?: string;
}
